import { getServiceCostsBeforeTax } from './getServiceCostsBeforeTax'
import { getServiceCosts } from './getServiceCosts'
import { getFeeCostsBeforeTax, getFeeCosts } from 'Rentlio/state/selectors/basketFee'

export function getReceipt(state, useSingleCancellationPolicy = false) {
  const receipt = {
    accomodation: {
      items: [],
      totalBeforeTax: 0,
      totalCost: 0
    },
    extras: {
      items: [],
      totalBeforeTax: 0,
      totalCost: 0
    },
    price: {
      total: 0,
      beforeTax: 0
    }
  }

  const accomodationItems = {}
  const extrasItems = {}
  let bookingEngineId = null

  const highestPriorityCancellationPolicy = state.basket
    .map(item => item.cancellationPolicy)
    .sort((a, b) => Number(a.orderNumber) - Number(b.orderNumber))[0]

  state.basket.map(basketItem => {
    const accomodationKey = `${basketItem.unitTypeId}_${basketItem.ratePlanId}`
    if (typeof accomodationItems[accomodationKey] === 'undefined') {
      accomodationItems[accomodationKey] = {
        name: basketItem.unitTypeName,
        ratePlanName: basketItem.ratePlanName,
        quantity: 0,
        priceBeforeTax: 0,
        price: 0,
        cancellationPolicy: null,
        isVatRegistered: basketItem.isVatRegistered,
        vatRate: basketItem.vatRate,
        currency: basketItem.currency,
        checkInBegin: basketItem.checkInBegin,
        checkInEnd: basketItem.checkInEnd,
        checkOutBegin: basketItem.checkOutBegin,
        checkOutEnd: basketItem.checkOutEnd,
        servicesCost: 0,
        firstNightPrice: 0,
        excludedTouristTaxAmount: 0,
        isTouristTaxIncluded: false
      }
    }

    bookingEngineId = basketItem.bookingEngineId
    accomodationItems[accomodationKey].quantity += 1
    accomodationItems[accomodationKey].price += basketItem.totalRate
    accomodationItems[accomodationKey].priceBeforeTax += basketItem.totalRateBeforeTax
    accomodationItems[accomodationKey].firstNightPrice += basketItem.firstNightPrice

    accomodationItems[accomodationKey].excludedTouristTaxAmount += basketItem.isTouristTaxIncluded
      ? 0
      : basketItem.touristTax || 0
    accomodationItems[accomodationKey].isTouristTaxIncluded = basketItem.isTouristTaxIncluded

    if (useSingleCancellationPolicy) {
      accomodationItems[accomodationKey].cancellationPolicy = highestPriorityCancellationPolicy
    } else if (basketItem.cancellationPolicy !== null) {
      accomodationItems[accomodationKey].cancellationPolicy = basketItem.cancellationPolicy
    }

    if (accomodationItems[accomodationKey].cancellationPolicy) {
      // get additional note from unit types, since cancellation policy is initially saved in basket and doesn't update on language change
      const unitType = state?.unitTypes?.find(({ unitTypeId }) => +unitTypeId === +basketItem?.unitTypeId)
      if (unitType) {
        const additionalNote = unitType.rates?.find(
          ({ policy }) => +policy.id === +accomodationItems[accomodationKey].cancellationPolicy.id
        )?.policy?.additionalNote
        if (additionalNote) {
          accomodationItems[accomodationKey].cancellationPolicy.additionalNote = additionalNote
        }
      }
    }

    basketItem.includedServices.map(name => {
      extrasItems[name] = {
        name,
        isIncluded: true,
        quantity: 0,
        priceBeforeTax: 0,
        price: 0,
        currency: basketItem.currency
      }
    })

    basketItem.services.map(service => {
      if (service.quantity === 0) {
        return
      }

      const serviceKey = `SERVICE_${service.id}`
      if (typeof extrasItems[serviceKey] === 'undefined') {
        extrasItems[serviceKey] = {
          name: service.name,
          quantity: 0,
          priceBeforeTax: 0,
          price: 0,
          isMandatory: service.isMandatory,
          paymentType: service.paymentType,
          currency: basketItem.currency
        }
      }

      extrasItems[serviceKey].quantity += service.quantity
      extrasItems[serviceKey].priceBeforeTax += getServiceCostsBeforeTax(service, state.request)
      extrasItems[serviceKey].price += getServiceCosts(service, state.request)
      accomodationItems[accomodationKey].servicesCost += getServiceCosts(service, state.request)
    })

    basketItem.fees.map(fee => {
      const feeKey = `FEE_${fee.id}`
      if (typeof extrasItems[feeKey] === 'undefined') {
        extrasItems[feeKey] = {
          name: fee.name,
          quantity: 1,
          priceBeforeTax: 0,
          price: 0,
          currency: basketItem.currency
        }
      }

      extrasItems[feeKey].priceBeforeTax += getFeeCostsBeforeTax(fee, state.request)
      extrasItems[feeKey].price += getFeeCosts(fee, state.request)
      accomodationItems[accomodationKey].servicesCost += getFeeCosts(fee, state.request)
    })
  })
  receipt.accomodation.items = Object.values(accomodationItems)
  receipt.extras.items = Object.values(extrasItems)
  receipt.vatRate = Object.values(accomodationItems)[0]?.vatRate
  receipt.isVatRegistered = Object.values(accomodationItems)[0]?.isVatRegistered
  receipt.currency = Object.values(accomodationItems)[0]?.currency
  receipt.bookingEngineId = bookingEngineId
  receipt.accomodation.totalCost = receipt.accomodation.items.reduce((sum, item) => sum + item.price, 0)
  receipt.accomodation.firstNightPrice = receipt.accomodation.items.reduce((sum, item) => sum + item.firstNightPrice, 0)
  receipt.extras.totalCost = receipt.extras.items.reduce((sum, item) => sum + item.price, 0)
  receipt.price.total = receipt.accomodation.totalCost + receipt.extras.totalCost

  receipt.price.beforeTax = receipt.accomodation.totalBeforeTax + receipt.extras.totalBeforeTax
  receipt.accomodation.totalBeforeTax = receipt.accomodation.items.reduce((sum, item) => sum + item.priceBeforeTax, 0)
  receipt.accomodation.taxAmount = receipt.accomodation.totalCost - receipt.accomodation.totalBeforeTax
  receipt.extras.totalBeforeTax = receipt.extras.items.reduce((sum, item) => sum + item.priceBeforeTax, 0)
  receipt.extras.taxAmount = receipt.extras.totalCost - receipt.extras.totalBeforeTax
  receipt.price.taxAmount = receipt.accomodation.taxAmount + receipt.extras.taxAmount

  return receipt
}
